import React from "react";
import { connect } from "react-redux";
import { Form, Col, Row } from "react-bootstrap";
import IntlTelInput from 'react-intl-tel-input';
import PropTypes from "prop-types";

import { deepEqual } from "../../../utils/object";
import { calculate } from "../../../utils/validation";

import GenerationsSelect from "../../../layout/select/generation";
import Address from "../../../layout/address";

import 'react-intl-tel-input/dist/main.css';
import 'react-datepicker/dist/react-datepicker.css';

class Company extends React.Component {
    
    constructor(props) {
        super(props);
        this.state = {
            Phone: {
                number: "",
                country: "us"
            }
        };
        this.phoneRef = React.createRef();
    }

    componentDidUpdate = (oldProps) => {
        if (!deepEqual(this.props, oldProps)) {
            var __props_minus_fields = { ...this.props };
            var __old_minus_fields = { ...oldProps };
            delete __props_minus_fields.fields;
            delete __old_minus_fields.fields;

            if (!deepEqual(__props_minus_fields, __old_minus_fields)) {
                this.setState({
                    ...this.state,
                    ...this.props
                });
            } 
            if (this.props.fields.length !== oldProps.fields.length)
                this.sendOnChange();
        }
    }

    onChange = (e) => {
        this.setState({
            ...this.state,
            [e.target.name]: e.target.value
        }, this.sendOnChange)
    }

    onAddressChange = (e) => {
        this.setState({
            ...this.state,
            Address: {
                ...this.state.Address,
                ...e
            }
        }, this.sendOnChange);
    }

    onPhoneChange = (isValid, newNumber, country, fullNumber, extension) => {

        this.setState({
            ...this.state,
            Phone: {
                ...this.state.Phone,
                country: country?.iso2?.toUpperCase() || "us",
                number: fullNumber,
                valid: isValid,
            }
        }, this.sendOnChange);
        this.phoneRef.current.setState({ cursorPosition: fullNumber.length });
    }

    sendOnChange = () => {
        if (this.props.onChange) {
            this.props.onChange({ ...this.state }, calculate(this.props.fields, "COMPANY", this.state));
        }
    }

    render() {
        return (
            <>
                <Row>
                    <Col lg="12">
                        <Row className="g-3">
                            <Col lg="12">
                                <h2 className="small-title">Company Information</h2>
                            </Col>
                        </Row>
                        <Row className="g-3">
                            <Col lg="5">
                                <div className="mb-3 top-label">
                                    <Form.Control type="text" name="firstName" value={this.state.name || ""} onChange={this.onChange} />
                                    <Form.Label>COMPANY NAME</Form.Label>
                                </div>
                            </Col>
                            <Col lg="4">
                                <div className="mb-3 top-label">
                                    <Form.Control type="text" name="dba" value={this.state.dba || ""} onChange={this.onChange} />
                                    <Form.Label>D/B/A</Form.Label>
                                </div>
                            </Col>
                            <Col lg="3">
                                <div className="mb-3 top-label">
                                    <IntlTelInput ref={ this.phoneRef } containerClassName="intl-tel-input" inputClassName="form-control" name="phone" id="phone" defaultCountry={this.state.Phone?.country?.toLowerCase() || "us"} autoPlaceholder={false} value={this.state.Phone?.number || ""} onPhoneNumberChange={this.onPhoneChange} formatOnInit />
                                    <Form.Label style={{ left: "55px" }}>PHONE #</Form.Label>
                                </div>
                            </Col>
                        </Row>
                    </Col>
                </Row>

                <Row className="g-3">
                    <Col lg="12">
                        <h2 className="small-title">Address</h2>
                    </Col>
                </Row>
                <Address {...this.state.Address} onChange={ this.onAddressChange } />

            </>
        )
    }
}

Company.propTypes = {
    fields: PropTypes.array,
};

const mapStateToProps = (state) => {
    return ({
        fields: state.fields.items
    });
};

export default connect(mapStateToProps)(Company);

